import Parallax from 'parallax-js'

export default {
    init() {

        this.scenes = []

        let i
        let scenesSelector = document.querySelectorAll('.parallax-wave__item')

        for(i = 0; i < scenesSelector.length; i++){
            this.scenes[i] = new Parallax(scenesSelector[i], {
                scalarX: 15,
                scalarY: 15,
            })
        }

    },
    scenesDisable() {

        let i

        for(i = 0; i < this.scenes.length; i++){
            this.scenes[i].disable()
        }

    },
    scenesEnable() {

        let i

        for(i = 0; i < this.scenes.length; i++){
            this.scenes[i].enable()
        }

    },
};
